import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ADD_ASSET,ASSET_CATEGORY, ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT } from '../../../Dropdownmanager';
import {
    Form,
    Row,
    Col,
    Typography,
    InputNumber,
    message,
} from 'antd';
import { handleMultipleAttachment } from '../../../blueplanitUtils/attachments';
import { addAssetEntry } from '../../../Slices/assetSlice';
import { getOptionsByPath } from '../../../utilsdata';
import { AntdButton, DatePickerField, InputField, SelectInput } from '../../../blueplanitUtils/InputField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';


const AddAsset = ({ onSuccess, onClose }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const AllAssets = useSelector((state) => state.Assets.allAssets);
    const details = useSelector((state) => state.employee.AllEmployees);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const [attachments, setattachments] = useState([])
    const [warrantyAttachments, setWarrantyAttachments] = useState([])
    const fileInputRef = useRef(null);
    const warrantyFileInputRef = useRef(null);

    const { Empid } = useParams();
    const id = loginUser?.id;
    const handleFinish = async (values) => {
        const existingAssetTagIds = AllAssets?.records?.map(asset => asset.assetTagId?.trim().toLowerCase()) || [];

        const newAssetTagId = values.assetTagId?.trim().toLowerCase();
        if (existingAssetTagIds.includes(newAssetTagId)) {
            message.error("Asset Tag ID already exists. Please use a unique one.");
            return;
        }
        let uploaded = [];
        let warrantyUploaded = [];
        if (attachments && attachments.length > 0) {
            uploaded = await handleMultipleAttachment(attachments, details, dispatch, id, Empid);
        }
        if (warrantyAttachments && warrantyAttachments.length > 0) {
            warrantyUploaded = await handleMultipleAttachment(warrantyAttachments, details, dispatch, id, Empid);
        }
        const resultAction = await dispatch(
            addAssetEntry({
                ...values,
                cost: values.cost ? parseFloat(values.cost) : null,
                purchaseDate: values.purchaseDate?.format('YYYY-MM-DD') || null,
                createdBy: `${loginUser?.firstname} ${loginUser?.lastname}`,
                attachments: uploaded,
                warrantyAttachments: warrantyUploaded,
            })
        );

        if (addAssetEntry.fulfilled.match(resultAction)) {
            message.success('Asset added!');
            form.resetFields();
            setattachments([]);
            setWarrantyAttachments([]);
            if (onSuccess) onSuccess();
            if (onClose) onClose();
        } else {
            message.error(resultAction.payload || 'Failed to add asset');
        }

    };

    const handleMultipleAttach = async (event, type = "asset") => {
        const files = Array.from(event.target.files);
        const freshAttachments = files.map(file => ({
            file,
            filename: file.name,
            url: URL.createObjectURL(file),
            type: file.type
        }));

        if (type === "warranty") {
            setWarrantyAttachments(freshAttachments);
        } else {
            setattachments(freshAttachments);
        }
    }

    
    return (
        <>
            <Typography.Title level={4} style={{ marginBottom: 24 }}>
                Add New Asset
            </Typography.Title>
 
            <Form layout="vertical" form={form} onFinish={handleFinish}>
                {/* Row 1 */}
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item name="assetTagId" required={false}label={
                            <span>
                                Asset Tag ID<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>}rules={[{ required: true,  message: 'Please enter Asset Tag ID'}]}>
                            <InputField size="small" placeholder="Asset Tag ID"  style={{ width: '100%', height: '31px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="productName" required={false}label={
                            <span>
                                Product Name<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>} rules={[{ required: true, message: 'Please enter Product Name' }]}>
                            <InputField size="small" placeholder="Product Name" style={{ width: '100%', height: '31px' }}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="cost"  required={false}label={
                            <span>
                                Cost<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>}rules={[{ required: true, message: 'Please enter Cost' }]}>
                            <InputNumber size="small" prefix="₹" style={{ width: '100%', height: '31px' }} placeholder="Enter cost" />
                        </Form.Item>
                    </Col>
                </Row>
 
                {/* Row 2 */}
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item name="purchaseDate"  required={false}label={
                            <span>
                                Purchase Date<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>} rules={[{ required: true, message: 'Please select a Purchase Date' }]}
                            className="tight-error-spacing">
                            <DatePickerField size="small" style={{ width: '100%' }} format="DD/MM/YYYY" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="purchasedFrom"  required={false}label={
                            <span>
                                Purchased From<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>} rules={[{ required: true, message: 'Please enter Purchased From' }]}>
                            <InputField size="small" placeholder="Vendor/Source"  style={{ width: '100%', height: '31px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="model" required={false}label={
                            <span>
                                Model<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>}rules={[{ required: true, message: 'Please enter Model'}]}>
                            <InputField size="small" placeholder="Model name"  style={{ width: '100%', height: '31px' }} />
                        </Form.Item>
                    </Col>
                </Row>
 
                {/* Row 3 */}
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item name="brand"required={false}label={
                            <span>
                                Brand<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>}
                             rules={[{ required: true,message: 'Please enter Brand' }]}>
                            <InputField size="small" placeholder="Brand name"  style={{ width: '100%', height: '31px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="category" required={false}label={
                            <span>
                                Category<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>} className="tight-error-spacing"
                            rules={[{ required: true, message: 'Please select a Category' }]}>
                            <SelectInput
                                size="small"
                                placeholder="Select Category"
                                style={{ width: '100%', height: '31px' }}
                                options={getOptionsByPath(NestedDatabucket, [ADD_ASSET, ASSET_CATEGORY])}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="department" required={false}label={
                            <span>
                                Department<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>} className="tight-error-spacing"
                            rules={[{ required: true, message: 'Please select a Department' }]}>
                            <SelectInput
                                size="small"
                                placeholder="Select Department"
                                style={{ width: '100%', height: '31px' }}
                                options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                            />
                        </Form.Item>
                    </Col>
 
                </Row>
 
                {/* Row 4 - Warranty Information */}
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item name="warrantyDuration" label="Warranty Duration (Months)">
                            <InputNumber
                                size="small"
                                style={{ width: '100%', height: '31px' }}
                                placeholder="Enter Warranty Duration "
                                min={0}
                            />
                        </Form.Item>
                    </Col>
 
                    <Col span={8}>
                        <Form.Item>
                            <input
                                type="file"
                                multiple
                                ref={fileInputRef}
                                onChange={(e) => handleMultipleAttach(e, "asset")}
                                style={{ display: 'none' }}
                            />
                            <Link onClick={() => fileInputRef.current && fileInputRef.current.click()}>
                                <AntdButton
                                    label="Asset Photo"
                                    icon={<FontAwesomeIcon icon={faUpload} />}
                                    type="primary"
                                    style={{
                                        borderRadius: '10px',
                                        fontWeight: 500,
                                        marginTop: '27px',
                                        marginLeft: '20px',
                                    }}
                                />
                            </Link>
 
                            {/* Asset Photos Display */}
                            {attachments && attachments.length > 0 && (
                                <div style={{ marginTop: '12px', marginLeft: '20px' }}>
                                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                        {attachments.map((attachment, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    background: '#e6f7ff',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    marginBottom: '4px',
                                                    minWidth: '80px',
                                                    maxWidth: '150px',
                                                }}
                                            >
                                                <span style={{ fontSize: '12px', wordBreak: 'break-all' }}>{attachment?.filename}</span>
                                                <AntdButton
                                                    type="text"
                                                    size="small"
                                                    label=" ×"
                                                    onClick={() => {
                                                        const updatedAttachments = attachments.filter((_, i) => i !== index);
                                                        setattachments(updatedAttachments);
                                                    }}
                                                    style={{
                                                        marginLeft: '4px',
                                                        padding: '0',
                                                        minWidth: 'auto',
                                                        height: 'auto',
                                                        lineHeight: '1',
                                                        color: '#ff4d4f',
 
                                                    }}
                                                />
 
 
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item>
                            <input
                                type="file"
                                multiple
                                ref={warrantyFileInputRef}
                                onChange={(e) => handleMultipleAttach(e, "warranty")}
                                style={{ display: 'none' }}
                            />
                            <Link onClick={() => warrantyFileInputRef.current && warrantyFileInputRef.current.click()}>
                                <AntdButton
                                    icon={<FontAwesomeIcon icon={faUpload} />}
                                    type="primary"
                                    label="Warranty Photo"
                                    style={{
                                        marginLeft: '-45px',
                                        marginTop: '27px',
                                        borderRadius: '10px',
                                        fontWeight: 500,
                                    }}
                                />
 
 
                            </Link>
 
                            {/* Warranty Photos Display */}
                            {warrantyAttachments && warrantyAttachments.length > 0 && (
                                <div style={{ marginTop: '12px', marginLeft: '-45px' }}>
                                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                        {warrantyAttachments.map((attachment, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    background: '#e6f7ff',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    marginBottom: '4px',
                                                    minWidth: '80px',
                                                    maxWidth: '150px',
 
                                                }}
                                            >
                                                <span style={{ fontSize: '12px', wordBreak: 'break-all' }}>{attachment?.filename}</span>
                                                <AntdButton
                                                    type="text"
                                                    size="small"
                                                    label=" ×"
                                                    onClick={() => {
                                                        const updatedWarrantyAttachments = warrantyAttachments.filter((_, i) => i !== index);
                                                        setWarrantyAttachments(updatedWarrantyAttachments);
                                                    }}
                                                    style={{
                                                        marginLeft: '4px',
                                                        padding: '0',
                                                        minWidth: 'auto',
                                                        height: 'auto',
                                                        lineHeight: '1',
                                                        color: '#ff4d4f'
                                                    }}
                                                />
 
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
 
                <Row>
                    <Col span={24}>
                        <Form.Item
                            name="description"
                             required={false}label={
                            <span>
                                Description<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                            </span>}
                            rules={[{ required: true, message: 'Please enter Description' }]}
                        >
                            <InputField placeholder="Enter asset description" />
                        </Form.Item>
                    </Col>
                </Row>
 
                <Row justify="center" gutter={16} style={{ marginTop: 24 }}>
                    <Col>
                        <AntdButton htmlType="submit" type="primary" label="Submit" />
                    </Col>
                    <Col>
                        <AntdButton
                            onClick={() => {
                                form.resetFields();
                                setattachments([]);
                                setWarrantyAttachments([]);
                                if (onClose) onClose();
                            }}
                            danger
                            label="Cancel"
                        />
                    </Col>
                </Row>
            </Form>
        </>
    );
};

export default AddAsset;  